import { useEffect, useState } from 'react';

// A phone turned sideways: touch screen, landscape, and short. Width alone can't tell it apart from a
// tablet or small laptop (a landscape phone is ~850-930px wide), so the layout breakpoints don't help.
const QUERY = '(pointer: coarse) and (orientation: landscape) and (max-height: 500px)';

const usePhoneLandscape = (): boolean => {
    const [matches, setMatches] = useState(() => typeof window !== 'undefined' && window.matchMedia(QUERY).matches);

    useEffect(() => {
        const media = window.matchMedia(QUERY);
        const onChange = () => setMatches(media.matches);
        onChange();
        media.addEventListener('change', onChange);
        return () => media.removeEventListener('change', onChange);
    }, []);

    return matches;
};

export default usePhoneLandscape;
